



export const locale = {
    lang: 'en',
    data: {
        'NOTIFICATION': {
            'TITLE': '',
            'SEARCH': 'Search',

            'NAME': '',

            'ACTION_RAISE': '',

            'CRITIQUE': '',

            'DATE': '',

            'REPEATABILITY': '',

            'SOURCE': '',

            'STATUT': '',

            'TYPE': '',

            'NEXT_NOTIFICATION': '',
            'INBOX': 'Inbox',
            'WATCHING': 'Archive',
            'MARK_AS_READ': 'Mark as read',
            'MARK_AS_UNREAD': 'Mark as unread',
            'MARK_ALL_AS_READ': 'Mark all as read',
            'MARK_ALL_AS_UNREAD': 'Mark all as unread',
            'CLEAR': 'Clear',
            'CLEAR_ALL': 'Clear all',
            'NO_NOTIFICATIONS': 'No notifications',
            'NO_NOTIFICATIONS_MESSAGE': 'When you have notifications, they will appear here.',
            'NOTIFICATIONS': 'Notifications',

        }
    }
};